/**
 * Ecap
 *
 * @module
 */

/**
 * @private
 * @return {void}
 */
function updateBackgroundPosition() {
    const bg = document.querySelector('.ecap-page-bg img');
    const header = document.querySelector('.header-bar');

    if (bg && header) {
        const contentTop = header.getBoundingClientRect().bottom + window.scrollY;
        // @ts-ignore: bg type should be HTMLElement.
        bg.style.top = `${contentTop}px`;
        // @ts-ignore: bg type should be HTMLElement.
        bg.style.height = `calc(100vh - ${contentTop}px)`;
        bg.classList.add('repositioned');
    }
}

/**
 * Init ecap widget UI updates.
 *
 * @return {void}
 */
export function init() {
    updateBackgroundPosition();
}
